<template>
    <div class="d-flex flex-column flex-root">
        <!--begin::Authentication - Sign-in -->
        <div class="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-cover bgi-attachment-fixed">
            <!--begin::Content-->
            <div class="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
                <!--begin::Logo-->
                <h1 class="text-dark mb-5"><img :src="'/admin/images/logo_mostra.png'" alt="Logo"></h1>
                <!--end::Logo-->
                <!--begin::Wrapper-->
                <div class="w-lg-500px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto">
                    <!--begin::Form-->
                    <form
                        @submit.prevent="form.post(this.route('login'))"
                        class="form w-100"
                        novalidate="novalidate"
                        id="kt_sign_in_form"
                    >
                        <!--begin::Heading-->
                        <div class="text-center mb-10">
                            <!--begin::Title-->
                            <h1 class="text-dark mb-3">Credenciais</h1>
                            <!--end::Title-->
                            <div class="text-gray-400 fw-bold fs-4">
                                Informe seus dados e acesse sua conta
                            </div>

                        </div>
                        <!--begin::Heading-->

                        <!--begin::Input group-->
                        <div class="fv-row mb-10">
                            <form-group label="E-mail ou CPF" :isInvalid="form.errors.email">
                                <input
                                    v-model="form.email"
                                    class="form-control form-control-lg form-control-solid"
                                    type="email"
                                    autocomplete="off"
                                    placeholder="Seu e-mail ou CPF"
                                    @blur="form.clearErrors('email')"
                                    :class="{'is-invalid': form.errors.email}"
                                />
                            </form-group>
                        </div>
                        <!--end::Input group-->

                        <!--begin::Input group-->
                        <div class="fv-row mb-10">
                            <form-group label="Senha" :is-invalid="form.errors.password">
                                <input
                                    v-model="form.password"
                                    class="form-control form-control-lg form-control-solid"
                                    type="password"
                                    autocomplete="off"
                                    placeholder="Sua senha"
                                    @blur="form.clearErrors('password')"
                                    :class="{'is-invalid': form.errors.password}"
                                />
                            </form-group>

                            <Link
                                :href="this.route('password.request')"
                                class="mt-3 link-primary fs-6 fw-bolder d-flex justify-content-end"
                            >
                                Esqueceu a senha?
                            </Link>
                        </div>
                        <!--end::Input group-->

                        <!--begin::Actions-->
                        <div class="text-center">
                            <submit-button label="Entrar" :processing="form.processing"></submit-button>
                            <div class="mt-10">
                              <span class="opacity-70 mr-2">Não possui uma conta? &nbsp;&nbsp;</span>
                              <a :href="this.route('register')" id="kt_login_signup"
                                 class="text-muted text-hover-primary font-weight-bold">
                                Novo Cadastro!
                              </a>
                            </div>
                        </div>
                        <!--end::Actions-->
                    </form>
                    <!--end::Form-->
                </div>
                <!--end::Wrapper-->
            </div>
            <!--end::Content-->
            <footer-auth />
        </div>
        <!--end::Authentication - Sign-in-->
    </div>
</template>


<script>
import SubmitButton from "@forms/SubmitButton";
import FormGroup from "@forms/FormGroup";
import FooterAuth  from "./FooterAuth"
import {useForm, Link} from '@inertiajs/inertia-vue3'

export default {
    components: {
        Link,
        SubmitButton,
        FormGroup,
        FooterAuth
    },
    setup() {
        const form = useForm({
            email: null,
            password: null,
        })

        return {form}
    },
}
</script>
